import BackgroundEffect from '../components/BackgroundEffect';
const CookiesPolicy = () => {
    const styles = {
        container: {
            maxWidth: "950px",
            margin: "50px auto",
            padding: "50px",
            background: "linear-gradient(180deg, #ffffff 0%, #f5f8fa 100%)",
            borderRadius: "16px",
            boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            fontFamily: "'Segoe UI', Roboto, sans-serif",
            color: "#003e64",
            lineHeight: "1.8",
            transition: "all 0.3s ease-in-out",
        },
        title: {
            fontSize: "2.6rem",
            fontWeight: "700",
            marginBottom: "10px",
            textAlign: "center",
            color: "#003e64",
            letterSpacing: "0.5px",
        },
        subtitle: {
            textAlign: "center",
            marginBottom: "35px",
            color: "#374651",
            fontSize: "1rem",
            backgroundColor: "#fdf3eb",
            padding: "15px",
            borderRadius: "10px",
            border: "1px solid #e87115",
        },
        section: {
            marginBottom: "35px",
            paddingBottom: "25px",
            borderBottom: "1px solid #e1e5e9",
        },
        sectionTitle: {
            fontSize: "1.3rem",
            fontWeight: "700",
            marginBottom: "12px",
            color: "#e87115",
            textTransform: "uppercase",
            letterSpacing: "0.6px",
        },
        list: {
            marginLeft: "25px",
            paddingLeft: "10px",
            listStyleType: "disc",
        },
        listItem: {
            marginBottom: "6px",
            fontSize: "1.2rem",
        },
        paragraph: {
            fontSize: "1.2rem",
            color: "#003e64",
            marginBottom: "12px",
        },
        footer: {
            borderTop: "2px solid #e87115",
            marginTop: "40px",
            paddingTop: "25px",
            fontSize: "0.95rem",
            textAlign: "center",
            color: "#003e64",
            fontWeight: "600",
            letterSpacing: "0.4px",
        },
        contact: {
            marginTop: "15px",
            lineHeight: "1.6",
        },
        link: {
            color: "#e87115",
            textDecoration: "none",
            fontWeight: "600",
        },
        linkHover: {
            textDecoration: "underline",
        },
    };

    return (
        <div style={styles.container}>
            <BackgroundEffect />
            <h1 style={styles.title}>Cookies Policy</h1>
            <p style={styles.subtitle}>
                <strong>Effective Date:</strong> 2nd September 2025 <br />
                <strong>Company:</strong> JSKM Technologies Private Limited <br />
                <strong>Website:</strong>{" "}
                <a
                    href="https://www.jskmtechnologies.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.link}
                >
                    https://www.jskmtechnologies.com
                </a>
                <br />
                <strong>Email:</strong>{" "}
                <a href="mailto:contact@jskmtechnologies.com" style={styles.link}>
                    contact@jskmtechnologies.com
                </a>
                <br />
                <strong>Phone:</strong> +91 96763 62000
            </p>

            {/* Section 1 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>1. What Are Cookies</h2>
                <p style={styles.paragraph}>
                    Cookies are small text files stored on your device when you visit our website or use our services. They help improve functionality, provide analytics, and enhance your user experience.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>2. Types of Cookies We Use</h2>
                <h3>1. Essential Cookies</h3>
                <ul style={styles.list}>
                    <li style={styles.listItem}>
                        Required for basic functionality of the website and services.
                    </li>
                    <li style={styles.listItem}>
                        Examples: login sessions, secure areas access.
                    </li>
                </ul>

                <h3>2. Analytics/Performance Cookies</h3>
                <ul style={styles.list}>
                    <li style={styles.listItem}>
                        Track website usage, traffic sources, and user behavior.
                    </li>
                    <li style={styles.listItem}>
                        Help us improve services, user interface, and content.
                    </li>
                </ul>

                <h3>3. Functional Cookies</h3>
                <ul style={styles.list}>
                    <li style={styles.listItem}>
                        Remember your preferences and settings.
                    </li>
                    <li style={styles.listItem}>
                        Enhance navigation and personalized experience.
                    </li>
                </ul>

                <h3>4. Marketing Cookies</h3>
                <ul style={styles.list}>
                    <li style={styles.listItem}>
                        Used for advertisements and promotional campaigns.
                    </li>
                    <li style={styles.listItem}>
                        Track interaction with ads to deliver relevant offers.
                    </li>
                </ul>
            </div>

            {/* Section 3 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>3. How We Use Cookies</h2>
                <p style={styles.paragraph}>Cookies help us:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Keep users logged in and maintain session state.</li>
                    <li style={styles.listItem}>Measure website and service performance.</li>
                    <li style={styles.listItem}>Analyze user behavior to improve services.</li>
                    <li style={styles.listItem}>Deliver targeted advertisements and marketing.</li>
                </ul>
            </div>

            {/* Section 4 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>4. Managing Cookies</h2>
                <p style={styles.paragraph}>
                    You can manage or disable cookies via your browser settings.
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Disabling essential cookies may affect website functionality.</li>
                    <li style={styles.listItem}>You can clear cookies at any time using your browser.</li>
                </ul>
                <p style={styles.paragraph}>
                    For detailed browser-specific instructions, refer to your browser documentation.
                </p>
            </div>

            {/* Section 5 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>5. Third-Party Cookies</h2>
                <p style={styles.paragraph}>
                    Some services (like analytics, advertisements, and payment processors) may place cookies on your device.<br />
                    JSKM Technologies is not responsible for third-party cookie practices. We recommend reviewing their privacy and cookie policies.
                </p>
            </div>
        </div>
    );
};

export default CookiesPolicy;